import { z } from "zod";

import { DocumentItemEditSchema } from "../../../../models/document-item";
import { DocumentWorkEditSchema } from "../../../../models/document-work";
import { DocumentPaymentFormSchema } from "../../../../models/document-payment";
import { DocumentClosingFormSchema } from "../../../../models/document-closing";
import { DocumentDepositAddSchema } from "../../../../models/document-deposit";



//create an array schema for works
export const WorksFormSchema = z.object({
    works: z.array(DocumentWorkEditSchema),
});

export type WorksFormType = z.infer<typeof WorksFormSchema>



//create an array schema for items
export const ItemsFormSchema = z.object({
    items: z.array(DocumentItemEditSchema),
});

export type ItemsFormType = z.infer<typeof ItemsFormSchema>



//create an array schema for items
export const PaymentsFormSchema = z.object({
    payments: z.array(DocumentPaymentFormSchema),
})

export type PaymentsFormType = z.infer<typeof PaymentsFormSchema>



// create an array schema for documentClosing
export const ClosingFormSchema = z.object({
    documents: z.array(DocumentClosingFormSchema),
})

export type ClosingFormType = z.infer<typeof ClosingFormSchema>



// create an array schema for deposits
export const DepositsFormSchema = z.object({
    deposits: z.array(DocumentDepositAddSchema),
})

export type DepostitsFormType = z.infer<typeof DepositsFormSchema>